import { PROFILE_ROUTE_NAMES } from '../../../constants/route'
import { useLinkLikeClick } from '../../../hooks'

function TasksWidgetItemContent({
  ContentContainer,
  profileLinkParams,
  request,
  ...restProps
}) {
  const { handleClick } = useLinkLikeClick()

  function handleClickTitle() {
    handleClick({
      link: PROFILE_ROUTE_NAMES.requestTask({
        additionalParams: profileLinkParams,
        id: request,
      }),
      outsideLink: true, // #TODO Remove after request profile realization
    })
  }

  return <ContentContainer {...restProps} onClickTitle={handleClickTitle} />
}

export default TasksWidgetItemContent
